import React, { useState } from "react";
import axios from "axios";
import { tomiApiUrl } from "../../utils/Api";
import { Modal } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

const LaunchModals = () => {

    const [email, setEmail] = useState("");
    const [nickname, setNickname] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ nickname: "", email: "" });


    const handleNameChange = (e) => {
        setNickname(e.target.value);
        if (error.nickname && e.target.value.trim().length > 0) {
            setError((prev) => ({ ...prev, nickname: "" }));
        }
    };
    
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (error.email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(e.target.value)) {
                setError((prev) => ({ ...prev, email: "" }));
            }
        }
    };

    const validateInputs = () => {
        let newErrors = { email: "", nickname: "" };
        let isValid = true;

        if (!email.trim()) {
            newErrors.email = "Email is required!";
            isValid = false;
        } else {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(email)) {
                newErrors.email = "Invalid email format!";
                isValid = false;
            }
        }

        if (!nickname.trim()) {
            newErrors.nickname = "Nickname is required!";
            isValid = false;
        }

        setError(newErrors);
        return isValid;
    };

    const handleSubmit = async () => {
        if (!validateInputs()) return;

        setLoading(true);
        setError({ email: "", nickname: "" });

        try {
            const response = await axios.post(`${tomiApiUrl}earlyAccessUser`, {
                email,
                name: nickname,
            });

            console.log(response, "response.....!");

            // Close the signup modal
            const signupModalEl = document.getElementById("exampleModal");
            if (signupModalEl) {
                let signupModal = window.bootstrap.Modal.getInstance(signupModalEl);
                if (!signupModal) {
                    signupModal = new window.bootstrap.Modal(signupModalEl);
                }
                signupModal.hide();
            }

            // Show the success modal
            const successModalEl = document.getElementById("exampleModal1");
            if (successModalEl) {
                let successModal = window.bootstrap.Modal.getInstance(successModalEl);
                if (!successModal) {
                    successModal = new window.bootstrap.Modal(successModalEl);
                }
                successModal.show();
            }
        } catch (err) {
            if (err.response?.status === 409) {
                const existingEmailMatch = err.response.data.message.match(/\((.*?)\)/);
                const existingEmail = existingEmailMatch ? existingEmailMatch[1] : "This email";
                setError({ email: `${existingEmail} already exists.`, nickname: "" });
            } else {
                setError({ email: err.response?.data?.message || "Something went wrong!", nickname: "" });
            }
        } finally {
            setLoading(false);
        }
    };


    const closeModal = () => {
        const modalEl = document.getElementById("exampleModal1");
        if (modalEl) {
            const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
    
        // Manually remove the backdrop
        setTimeout(() => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
            }
            document.body.classList.remove("modal-open"); // Prevents scrolling issue
        }, 300); // Delay to ensure Bootstrap animation finishes
    };
    


    return (
        <>
            {/* Signup Modal */}
            <div className="modaltopdivhome">
                <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5"></h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="bannertopmodal">
                                    <div className="cntmodalhome">
                                        <h2>TOMI is Launching Soon!</h2>
                                        <p>Sign up now for early access and an exclusive airdrop at launch.</p>
                                    </div>
                                </div>
                                <div className="inputmodal">
                                   <div className="w-100">
                                   <input
                                        type="email"
                                        placeholder="Email Address"
                                        value={email}
                                        onChange={handleEmailChange} // ✅ Corrected
                                        className={error.email ? "error emailinputmodal" : "emailinputmodal"}
                                    />
                                    {error.email && <p className="error-text">{error.email}</p>}
                                   </div>
                                    <div className="w-100">
                                        
                                    <input
                                        className={error.nickname ? "error emailinputmodal" : "emailinputmodal"}
                                        type="text"
                                        placeholder="Nickname"
                                        value={nickname}
                                        onChange={handleNameChange} // ✅ Corrected
                                    />
                                    {error.nickname && <p className="error-text">{error.nickname}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary modaldonebtn"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "I'm In!"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            {/* Success Modal */}
            <div className="modaltopdivhome">
                <div className="modal fade" id="exampleModal1" tabIndex="-1" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="exampleModalLabel1"></h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="modaltickerprnt">
                                    <div className="cntmodalhome">
                                        <img src="/assets/modalticker.png" alt="tickimg" />
                                        <h2>You're in!</h2>
                                        <p>Expect more info as we get closer to launch.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="modaldonebtn"
                                    // data-bs-dismiss="modal" aria-label="Close"
                                    onClick={closeModal}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LaunchModals;